import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";

export const PageWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 48px;
  margin: 48px 0;
  width: 100%;
  @media only screen and (max-width: 600px) {
    gap: 32px;
    margin: 32px 0;
  }
`;

export const Description = styled(Typography)`
  font-size: 16px;
  color: ${theme.colorsV2.gray.shade_800};
`;

export const QuestionList = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ConditionList = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const SectionsWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px;
  @media only screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
